export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: 'korean' | 'japanese' | 'chinese';
  tags: string[];
  rating: number;
  description: string;
  status: 'ongoing' | 'completed';
  chapters: number;
  views: number;
  updatedAt: string;
  isHot: boolean;
  isNew: boolean;
}

export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { slug: 'korean', name: '韩漫', icon: 'ri-heart-pulse-line', description: '韩国漫画精选，画风精美剧情丰富' },
  { slug: 'japanese', name: '日漫', icon: 'ri-sun-line', description: '经典日本漫画，热血与治愈并存' },
  { slug: 'chinese', name: '国漫', icon: 'ri-vip-crown-line', description: '国产漫画崛起之作，品质保证' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '剑与魔法',
    author: '星辰工作室',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20comic%20cover%20featuring%20a%20handsome%20male%20warrior%20with%20a%20sword%20in%20medieval%20fantasy%20setting%2C%20dramatic%20lighting%2C%20detailed%20character%20art%2C%20soft%20background%20with%20magical%20particles%2C%20professional%20comic%20illustration%20style&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    category: 'korean',
    tags: ['奇幻', '冒险', '热血'],
    rating: 9.2,
    description: '在一个被魔法与剑统治的世界里，少年剑士踏上寻找传说之剑的冒险旅程。精美画风与扣人心弦的剧情，带你进入一个宏大的奇幻世界。',
    status: 'ongoing',
    chapters: 156,
    views: 1250000,
    updatedAt: '2026-08-03',
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-2',
    title: '恋爱方程式',
    author: '樱花动漫社',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20romance%20comic%20cover%20featuring%20a%20beautiful%20high%20school%20girl%20and%20boy%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20tones%2C%20gentle%20spring%20atmosphere%2C%20clean%20illustration%20style%20with%20warm%20lighting&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    category: 'japanese',
    tags: ['恋爱', '校园', '治愈'],
    rating: 8.9,
    description: '高中二年级的春天，她遇见了改变一生的那个人。温馨治愈的校园恋爱故事，每一页都充满了青春的味道。',
    status: 'completed',
    chapters: 89,
    views: 980000,
    updatedAt: '2026-07-28',
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-3',
    title: '斗破苍穹',
    author: '天蚕土豆',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20martial%20arts%20comic%20cover%20featuring%20a%20powerful%20male%20cultivator%20with%20flaming%20aura%20in%20ancient%20Chinese%20setting%2C%20dramatic%20composition%2C%20golden%20and%20red%20color%20scheme%2C%20epic%20fantasy%20illustration&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    category: 'chinese',
    tags: ['玄幻', '热血', '修仙'],
    rating: 9.5,
    description: '天才少年萧炎，在创造了家族空前绝后的修炼纪录后突然陨落，经过药老悉心教导，重新踏上巅峰之路。国漫经典之作！',
    status: 'ongoing',
    chapters: 320,
    views: 5600000,
    updatedAt: '2026-08-04',
    isHot: true,
    isNew: true,
  },
  {
    id: 'comic-4',
    title: '密室逃脱',
    author: '暗影社',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20cover%20featuring%20a%20group%20of%20people%20in%20a%20dark%20mysterious%20room%20with%20tense%20expressions%2C%20suspenseful%20atmosphere%2C%20dramatic%20shadows%2C%20psychological%20thriller%20comic%20art%20style&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    category: 'korean',
    tags: ['悬疑', '惊悚', '推理'],
    rating: 9.0,
    description: '十个人被困在一座神秘建筑中，必须通过层层密室才能逃生。每个密室都隐藏着惊人的秘密，谁能活到最后？',
    status: 'ongoing',
    chapters: 67,
    views: 780000,
    updatedAt: '2026-08-01',
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-5',
    title: '海贼传说',
    author: '海洋工作室',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20adventure%20manga%20cover%20featuring%20a%20young%20pirate%20captain%20on%20a%20ship%20deck%20with%20ocean%20waves%20in%20background%2C%20golden%20sunset%20lighting%2C%20dynamic%20pose%2C%20classic%20shonen%20manga%20illustration%20style&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    category: 'japanese',
    tags: ['冒险', '热血', '友情'],
    rating: 9.3,
    description: '少年路克怀揣着成为海贼王的梦想，与伙伴们一起踏上伟大航路的冒险。经典热血漫画，燃到爆炸！',
    status: 'ongoing',
    chapters: 245,
    views: 3200000,
    updatedAt: '2026-08-03',
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-6',
    title: '狐妖小红娘',
    author: '小新',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20manhua%20cover%20featuring%20a%20beautiful%20fox%20spirit%20girl%20with%20traditional%20Chinese%20red%20dress%2C%20flowing%20long%20hair%2C%20elegant%20ancient%20Chinese%20palace%20background%2C%20soft%20dreamy%20atmosphere%2C%20romantic%20illustration&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    category: 'chinese',
    tags: ['爱情', '奇幻', '古风'],
    rating: 9.4,
    description: '以红线仙为主角，讲述人与妖之间的爱情故事。唯美古风画风，感人至深的情节，国漫良心之作。',
    status: 'ongoing',
    chapters: 198,
    views: 2100000,
    updatedAt: '2026-07-30',
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-7',
    title: '重生之都市修仙',
    author: '飞卢工作室',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20urban%20cultivation%20manhua%20cover%20featuring%20a%20young%20man%20in%20modern%20city%20with%20spiritual%20energy%20surrounding%20him%2C%20contrast%20between%20modern%20skyscrapers%20and%20ancient%20cultivation%20elements%2C%20cool%20blue%20and%20white%20tones&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    category: 'chinese',
    tags: ['都市', '修仙', '重生'],
    rating: 8.8,
    description: '一代仙尊重生回到地球都市时代，凭借前世记忆与修为，在这个末法时代重新踏上修真之路。',
    status: 'ongoing',
    chapters: 412,
    views: 4800000,
    updatedAt: '2026-08-04',
    isHot: true,
    isNew: true,
  },
  {
    id: 'comic-8',
    title: '我的野蛮女友',
    author: '韩流漫画',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romantic%20comedy%20manhwa%20cover%20featuring%20a%20cute%20couple%20in%20modern%20Seoul%20street%20scene%2C%20playful%20expressions%2C%20bright%20daytime%20lighting%2C%20fashionable%20clothing%2C%20lighthearted%20comic%20illustration%20style&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    category: 'korean',
    tags: ['恋爱', '喜剧', '都市'],
    rating: 8.7,
    description: '一个普通大学生遇到了一个性格火爆的女生，从此生活发生了翻天覆地的变化。爆笑又甜蜜的恋爱喜剧！',
    status: 'completed',
    chapters: 120,
    views: 1500000,
    updatedAt: '2026-06-15',
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-9',
    title: '死神代理人',
    author: '暗夜工坊',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20dark%20fantasy%20manga%20cover%20featuring%20a%20mysterious%20character%20in%20black%20coat%20holding%20a%20scythe%2C%20gothic%20atmosphere%2C%20moonlight%20scene%2C%20dark%20purple%20and%20silver%20color%20scheme%2C%20supernatural%20action%20illustration&width=400&height=560&seq=manga-cover-09&orientation=portrait',
    category: 'japanese',
    tags: ['奇幻', '战斗', '暗黑'],
    rating: 9.1,
    description: '少年意外成为死神代理人，在人间与冥界之间执行任务。华丽的战斗场面与深刻的人性探讨，暗黑系神作！',
    status: 'ongoing',
    chapters: 178,
    views: 1900000,
    updatedAt: '2026-08-02',
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-10',
    title: '美食的俘虏',
    author: '美味社',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20food%20adventure%20manga%20cover%20featuring%20delicious%20cuisine%20and%20a%20cheerful%20chef%20character%2C%20colorful%20food%20illustrations%2C%20vibrant%20and%20appetizing%20composition%2C%20warm%20orange%20and%20yellow%20tones%2C%20gourmet%20comic%20art&width=400&height=560&seq=manga-cover-10&orientation=portrait',
    category: 'japanese',
    tags: ['美食', '冒险', '搞笑'],
    rating: 8.6,
    description: '在这个美食至上的世界里，美食猎人为了寻找传说中的终极食材而展开冒险。看完绝对会饿！',
    status: 'completed',
    chapters: 96,
    views: 850000,
    updatedAt: '2026-05-20',
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-11',
    title: '全职高手',
    author: '蝴蝶蓝',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20esports%20manhua%20cover%20featuring%20a%20cool%20male%20gamer%20with%20headset%20and%20gaming%20keyboard%2C%20futuristic%20gaming%20arena%20background%2C%20dynamic%20neon%20lighting%20effects%2C%20competitive%20gaming%20atmosphere%2C%20professional%20illustration&width=400&height=560&seq=manga-cover-11&orientation=portrait',
    category: 'chinese',
    tags: ['电竞', '热血', '竞技'],
    rating: 9.6,
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，遭到俱乐部驱逐后重新崛起的故事。国漫巅峰之作！',
    status: 'ongoing',
    chapters: 280,
    views: 6200000,
    updatedAt: '2026-08-04',
    isHot: true,
    isNew: true,
  },
  {
    id: 'comic-12',
    title: '独行月球',
    author: '太空社',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20sci-fi%20comedy%20manhwa%20cover%20featuring%20an%20astronaut%20alone%20on%20the%20moon%20surface%20with%20Earth%20in%20background%2C%20humorous%20expression%2C%20starry%20space%20atmosphere%2C%20clean%20sci-fi%20illustration%20style&width=400&height=560&seq=manga-cover-12&orientation=portrait',
    category: 'korean',
    tags: ['科幻', '喜剧', '生存'],
    rating: 9.0,
    description: '被遗忘在月球上的宇航员，独自一人在月球上求生的爆笑故事。孤独与幽默并存的神奇作品！',
    status: 'completed',
    chapters: 72,
    views: 2100000,
    updatedAt: '2026-07-10',
    isHot: false,
    isNew: false,
  },
];

export const categoryLabels: Record<string, string> = {
  korean: '韩漫',
  japanese: '日漫',
  chinese: '国漫',
};